import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const StockReturnList = lazy(() => import('../Pages/StockReturnList'));
const AddStockReturn = lazy(() => import('../Pages/AddStockReturn'));
const EditStockReturn = lazy(() => import('../Pages/EditStockReturn'));
const StockReturnView = lazy(() => import('../Pages/StockReturnView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';

LoadingOverlay.propTypes = undefined;

function StockReturnRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/stock/return"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockReturnList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/list"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockReturnList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/add"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AddStockReturn history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/edit/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <EditStockReturn history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/view/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <StockReturnView history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default StockReturnRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
